/**
 * Given a locale, return the first day of the week.
 *
 * @param {string} locale
 * @returns {number} 0 (Sunday) or 1 (Monday)
 */
export const getFirstDayOfWeek = (locale) => {
    const usLocales = ['en_US', 'es_US'];

    return usLocales.indexOf(locale) !== -1 ? 0 : 1;
};
